export enum SubscribeCategoryGroupCode {
    // 订阅默认非会员入口
    PayDefaultVip = 'X_design_Pay',
    // 订阅默认美叶入口
    PayDefaultCredit = 'X_design_PayMy',
}

export enum Entrance {
    TopNav = 'topnav',
    Func = 'func',
    Save = 'save',
    Open = 'open',
    Times = 'times',
    Watermark = 'watermark',
    Material = 'material',
    ToolPanel = 'tool_panel',
    Share = 'share',
    Other = 'other',
    Quick = 'quick',
    AutoLogin = 'auto_login',
    AutoSave = 'auto_save',
    Business = 'business',
}

/**
 * 图文过审type类型
 */
export enum SensitiveCheckType {
    /**
     * ai logo
     */
    AI_LOGO = 'ai_logo_business_id',
    /**
     * ai ppt
     */
    AI_PPT = 'ai_ppt_result_business_id',
    /**
     * ai 海报
     */
    AI_POSTER = 'ai_poster_business_id',
}

export enum SdkModuleName {
    poster = 'ai-poster-sdk',
    template = 'template-sdk',
    image = 'image-editor-sdk',
}

/**
 * 编辑器类型
 */
export enum IEditorType {
    posterEditor = 'posterEditor',
    imageEditor = 'imageEditor',
}

/** 副本事件类型 */
export enum ActionType {
    FetchData = 'FetchData',
}

/** 副本消息类型 */
export enum MessageType {
    Fetch = 'fetch',
    Post = 'post',
}
